import { LinkedinLogo } from "@phosphor-icons/react";
import { C } from "@/brand/tokens";
import { whyFirm6, brand6 } from "@/brand/contentF6";
import { FounderPortrait } from "@/components/brand/FounderPortrait";
import { Box6 } from "@/components/common/Box6";
import { Eyebrow6 } from "@/components/common/Eyebrow6";
import { TextLink6 } from "@/components/common/TextLink6";

/** WhyFirmSection6 — four boxed firm signals + restrained founder module. */
export function WhyFirmSection6() {
  return (
    <section id="why" data-testid="why-firm-6" style={{ background: C.surfaceLight, color: C.textOnLight }}>
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <Eyebrow6 className="mb-6">{whyFirm6.eyebrow}</Eyebrow6>
            <h2
              className="font-cormorant mb-10"
              style={{
                color: C.textOnLight,
                fontSize: "clamp(1.9rem, 3.4vw, 2.8rem)",
                fontWeight: 400,
                lineHeight: 1.08,
                letterSpacing: "-0.012em",
                maxWidth: "20ch",
              }}
            >
              {whyFirm6.headline}
            </h2>

            <div className="grid sm:grid-cols-2 gap-5" data-testid="why-signals-grid">
              {whyFirm6.signals.map((s, i) => (
                <Box6 as="article" key={s.label} tone="parchment" radius="resource" className="p-7" data-testid={`why-signal-${i}`}>
                  <p
                    className="font-inter text-[10.5px] uppercase font-semibold pb-3 mb-4"
                    style={{ color: C.accentMetal, letterSpacing: "0.24em", borderBottom: `1px solid ${C.brassSoft}` }}
                  >
                    {String(i + 1).padStart(2, "0")} · {s.label}
                  </p>
                  <p className="font-inter leading-[1.65]" style={{ color: C.inkOnLight, fontSize: "0.95rem" }}>
                    {s.body}
                  </p>
                </Box6>
              ))}
            </div>
          </div>

          <Box6 as="aside" tone="blue" radius="card" className="lg:col-span-5 p-8 lg:p-10 flex flex-col" data-testid="founder-module-6">
            <p
              className="font-inter text-[11px] uppercase font-semibold pb-4 mb-7"
              style={{ color: C.accentMetal, letterSpacing: "0.28em", borderBottom: `1px solid ${C.brassSoft}` }}
            >
              {whyFirm6.founder.eyebrow}
            </p>

            <div className="grid grid-cols-12 gap-6 items-start">
              <div className="col-span-5 sm:col-span-4">
                <FounderPortrait caption={null} lazy />
              </div>
              <div className="col-span-7 sm:col-span-8">
                <p className="font-cormorant" style={{ color: C.textOnDark, fontSize: "clamp(1.3rem, 1.9vw, 1.6rem)", fontWeight: 400, lineHeight: 1.2 }}>
                  {whyFirm6.founder.line}
                </p>
              </div>
            </div>

            <p className="mt-7 font-inter leading-[1.7] grow" style={{ color: C.whiteOnDark, fontSize: "0.98rem" }}>
              {whyFirm6.founder.statement}
            </p>

            <div className="mt-8 pt-6 flex flex-wrap items-center gap-x-8 gap-y-4" style={{ borderTop: `1px solid ${C.brassSoft}` }}>
              <TextLink6 to={whyFirm6.founder.cta.href} tone="light" testId="meet-katrina-link">
                {whyFirm6.founder.cta.label}
              </TextLink6>
              <a
                href={brand6.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid="founder-linkedin-link"
                className="inline-flex items-center gap-2 font-inter text-[11px] uppercase font-semibold transition-colors"
                style={{ color: C.whiteOnDarkSoft, letterSpacing: "0.22em" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = C.textOnDark)}
                onMouseLeave={(e) => (e.currentTarget.style.color = C.whiteOnDarkSoft)}
              >
                <LinkedinLogo size={15} weight="regular" />
                LinkedIn
              </a>
            </div>
          </Box6>
        </div>
      </div>
    </section>
  );
}
